import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import { activityStatusById, activityStatuses, activityStatusReasons } from "features/activity/activityConsts";
import { useGetActivityStatusReasonsQuery, useGetWorkOrderInfoQuery } from "features/activity/activitySlice";
import ActivityStatusAliasView from "features/activityStatusAlias";
import { useState } from "react";
import { IssueTrackerCompleteWorkflowStyle } from "./style";
import CloseIcon from '@material-ui/icons/Close';
import CustomInput from "components/CustomInput";
import { Alert } from "@mui/material";
import { NoteContent } from "features/notes/NoteContent";

export const IssueTrackerCompleteWorkflow = ({ issue, open, onSave, onCancel }) => {

    const classes = IssueTrackerCompleteWorkflowStyle();

    let { data: workorder, error: vehicleDetailsError, isLoading: isVehicleDetailsLoading, refetch: refecthLog } = useGetWorkOrderInfoQuery(issue?.linkedWorkOrders?.[0]?.id, { skip: !open || !issue?.linkedWorkOrders });
    workorder = workorder?.data;
    let { data: statusReasons, error: statusReasonsError, isLoading: isLoadingStatusReasons } = useGetActivityStatusReasonsQuery();
    statusReasons = statusReasons || [];    
    
    const [activityStatus, setActivityStatus] = useState();
    const [reasonId, setReasonId] = useState();
    const [note, setNote] = useState();

    const onChangeStatus = (status) => {
        setActivityStatus(status);
    }

    const onSaveAction = async (saveStatus) => {
        saveStatus ? onSave(activityStatus, reasonId, note?.content) : onSave(null);
        setReasonId();
        setNote();
        setActivityStatus();
    };

    const onChangeNote = (key, val) => {
        switch (key) {
            case "content":
                setNote({ ...note, content: val });
                break;
            case "viewByClient":
                setNote({ ...note, viewByClient: val })
        }
    }

    const disabled = !activityStatus || (parseInt(activityStatus) === activityStatuses.Exception && !reasonId) 
                    || (reasonId == activityStatusReasons.Other && !(note?.content?.replace(/<[^>]+>/g, '')?.trim()));
    
    return (<>
        <Dialog open={open} fullWidth maxWidth='sm' >
            <DialogTitle>
                <Grid container justifyContent="space-between" alignItems="center">
                    <div>Resolve Ticket & Linked Activity</div>
                    <CloseIcon className={classes.closeIcon} onClick={() => { onCancel(); setActivityStatus(); setReasonId(); }} />
                </Grid>
            </DialogTitle>
            <DialogContent >
                <Grid container direction="column" className={classes.content}>
                    <div className={classes.text} >
                        You are about to resolve the ticket, would you like to update the status of the linked activity?
                    </div>
                    <Grid item alignItems='center' container spacing={1} className={classes.text}>
                        <Grid item>Current activity status is:</Grid>
                        <div style={{ fontWeight: '500' }}>{activityStatusById?.[workorder?.activityId]?.name}</div>
                    </Grid>
                    <Grid item alignItems='center' container spacing={1} className={classes.text}>
                        <Grid item>Update Status To:</Grid>
                        <ActivityStatusAliasView
                            clientId={workorder?.vehicle?.clientId}
                            readonly={false}
                            onChange={val => onChangeStatus(val)}
                            selectCompleteStatusesdOnly
                            label={''}
                        />
                        {activityStatus == activityStatuses.Exception && <>
                            {!reasonId && <div style={{paddingBottom: '.5em', paddingTop: '.5em'}}>
                                <Alert sx={4} severity="warning">Please select a reason for the exception</Alert>
                            </div>}
                            <div style={{paddingTop: '.5em'}}><CustomInput
                                id="reasonId"
                                label="Reason"
                                elementType="dropdown"
                                values={statusReasons}
                                value={reasonId}
                                required={activityStatus === activityStatuses.Exception}
                                showEmpty={true}
                                onChange={val => setReasonId(val)}
                            /></div>
                        </>}

                        {reasonId == activityStatusReasons.Other &&
                            <Grid container style={{ paddingTop: '.5em' }}>
                                {(!note?.content?.replace(/<[^>]+>/g, '')?.trim()) && <Grid item xs={12}>
                                    <Alert severity="error">Note is required</Alert>
                                </Grid>}
                                <Grid item xs={12} style={{ paddingTop: '.5em' }}>
                                    <NoteContent content={note?.content} viewByClient={note?.viewByClient} onChange={onChangeNote} />
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onSaveAction(false)} variant='outlined'>
                    No, save the ticket only
                </Button>
                <Button disabled={disabled} onClick={() => onSaveAction(true)} variant='outlined' color='primary'>
                    Yes, save the ticket and update the activity
                </Button>
            </DialogActions>
        </Dialog>
    </>
    )
}